var map = {
	"./Angelshark.webp": 96,
	"./Anglerfish.webp": 251,
	"./Blue Whale.webp": 919,
	"./Bluefish.webp": 64,
	"./Burbot.webp": 864,
	"./Catfish.webp": 132,
	"./Clownfish.webp": 301,
	"./Cod.webp": 260,
	"./Crab.webp": 728,
	"./Dolphin.webp": 570,
	"./Eel.webp": 712,
	"./Firefish.webp": 660,
	"./Goldfish.webp": 42,
	"./Gray Whale.webp": 912,
	"./Lake Sturgeon.webp": 518,
	"./Loch.webp": 424,
	"./Mandarinfish.webp": 300,
	"./Narwhal.webp": 765,
	"./Northern Pike.webp": 699,
	"./Oranda.webp": 119,
	"./Orca Whale.webp": 710,
	"./Redtail Catfish.webp": 653,
	"./Sardine.webp": 766,
	"./Seagulls.webp": 666,
	"./Shark.webp": 931,
	"./Shrimp.webp": 389,
	"./Squid.webp": 496,
	"./Starfish.webp": 531,
	"./Swordfish.webp": 997,
	"./Turtle.webp": 820
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 284;